export default __webpack_public_path__ + "static/media/Vector.b2dc6f7b.svg";